var data = {
	"body": "<path d=\"M18 18H6V6h12v12z\" fill=\"currentColor\"/>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
